import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DeleteEntityModule } from 'src/app/shared/delete-entity/delete-entity.module';
import { VoiceInputModule } from 'src/app/shared/ai-assistant/voice-input/voice-input.module';
import { FormalizeCommentModule } from 'src/app/shared/ai-assistant/formalize-comment/formalize-comment.module';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { CompanyPageChangeCompanyStateModalComponent } from './company-page-change-company-state-modal.component';

@NgModule({
  declarations: [CompanyPageChangeCompanyStateModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
    DeleteEntityModule,
    VoiceInputModule,
    FormalizeCommentModule,
    SkeletonLoaderModule
  ],
  exports: [CompanyPageChangeCompanyStateModalComponent],
  entryComponents: [CompanyPageChangeCompanyStateModalComponent]
})
export class CompanyPageChangeCompanyStateModalModule { }
